import { render } from "./Editor.vue?vue&type=template&id=b386a87c&ts=true&lang=pug"
import script from "./Editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./Editor.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__